<template>
  <el-dialog
    v-model="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    center
    custom-class="scanner-error-dialog"
  >
    <div class="scanner-error-content">
      <div class="scanner-error-icon">⚠️</div>
      <h2 class="scanner-error-title">{{ $t('connect_fs_scanner_error') }}</h2>
      <p class="scanner-error-message">{{ $t('attempting_to_reconnect') }}</p>
      <div class="scanner-loading">
        <div class="scanner-loading-dot"></div>
        <div class="scanner-loading-dot"></div>
        <div class="scanner-loading-dot"></div>
      </div>
    </div>
  </el-dialog>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'

@Options({
  name: 'ScannerErrorModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
})
export default class ScannerErrorModal extends Vue {
  visible!: boolean
}
</script>

<style lang="scss" scoped>
.scanner-error-dialog {
  ::v-deep(.el-dialog__body) {
    padding: 40px;
  }
}

.scanner-error-content {
  text-align: center;
  padding: 20px;
}

.scanner-error-icon {
  font-size: 80px;
  margin-bottom: 20px;
}

.scanner-error-title {
  font-size: 24px;
  font-weight: bold;
  color: #e6a23c;
  margin-bottom: 15px;
}

.scanner-error-message {
  font-size: 16px;
  color: #606266;
  margin-bottom: 30px;
}

.scanner-loading {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.scanner-loading-dot {
  width: 12px;
  height: 12px;
  background-color: #409eff;
  border-radius: 50%;
  animation: loading-bounce 1.4s infinite ease-in-out both;
}

.scanner-loading-dot:nth-child(1) {
  animation-delay: -0.32s;
}

.scanner-loading-dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes loading-bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>
